import React, { useEffect, useState } from "react";
import { FaInstagram, FaUserTie } from "react-icons/fa";
import { MdShoppingCart, MdSupportAgent } from "react-icons/md";
import { FaFacebookF, FaUser, FaLock } from "react-icons/fa";
import { AiOutlineTwitter } from "react-icons/ai";
import { ImSearch } from "react-icons/im";
import { TiHeartFullOutline } from "react-icons/ti";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_card_products,
  get_wishlist_products,
} from "../store/reducers/cardReducer";
import logo from "../assets/Icon.png";

const Headers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categorys } = useSelector((state) => state.home);
  const { userInfo } = useSelector((state) => state.auth);
  const { card_product_count, wishlist_count } = useSelector(
    (state) => state.card
  );

  const { pathname } = useLocation();
  const [searchValue, setSearchValue] = useState("");
  const [category, setCategory] = useState("");

  const search = () => {
    navigate(`/products/search?category=${category}&&value=${searchValue}`);
  };
  const redirect_card_page = () => {
    if (userInfo) {
      navigate(`/card`);
    } else {
      navigate(`/login`);
    }
  };

  useEffect(() => {
    if (userInfo) {
      dispatch(get_card_products(userInfo.id));
      dispatch(get_wishlist_products(userInfo.id));
    }
  }, [dispatch, userInfo]);
  return (
    <div className="w-full bg-[whitesmoke]">
      <div className="header-top bg-primary md-lg:hidden">
        <div className="w-[85%] lg:w-[90%] mx-auto">
          <div className="flex w-full justify-between items-center h-[50px] text-slate-300">
            <ul className="flex justify-start items-center gap-8">
              <li className="flex relative text-sm justify-center items-center gap-2 after:absolute after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]">
                <span>
                  <MdSupportAgent />
                </span>
                <Link to={"/contact"}>Contact Us</Link>
              </li>
              <li className="flex relative text-sm justify-center items-center gap-2 after:absolute after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px]">
                <span>
                  <FaUserTie />
                </span>
                <Link to={"/dashboard/chat/6630123b079f6ca6a6e05460"}>
                  Customer Support
                </Link>
              </li>
            </ul>
            <div>
              <div className="flex justify-center items-center gap-10">
                <div className="flex justify-center items-center gap-4">
                  {/* <a className='text-slate-300 hover:text-secondary' href="#"><FaFacebookF /></a>
                                    <a className='text-slate-300 hover:text-secondary' href="#"><AiOutlineTwitter /></a> */}
                  <a
                    className="text-slate-300 hover:text-secondary"
                    target="_blank"
                    href="https://www.instagram.com/tweaksandtucks?utm_source=qr&igsh=NTc4MTIwNjQ2YQ== "
                  >
                    <FaInstagram />
                  </a>
                </div>

                {userInfo ? (
                  <Link
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm"
                    to="/dashboard"
                  >
                    <span>
                      <FaUser />
                    </span>
                    <span>{userInfo.name}</span>
                  </Link>
                ) : (
                  <Link
                    to="/login"
                    className="flex cursor-pointer justify-center items-center gap-2 text-sm"
                  >
                    <span>
                      <FaLock />
                    </span>
                    <span>Login</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-white">
        <div className="w-[96%] lg:w-[96%] mx-auto">
          <div className="h-[80px] md-lg:h-[100px] flex justify-between items-center flex-wrap">
            <div className="md-lg:w-full w-3/12 md-lg:pt-4">
              <div className="flex justify-between md:justify-center items-center ">
                <Link
                  className="flex mt-2 ml-2 justify-center items-center"
                  to="/"
                >
                  <img className="h-18 w-14" src={logo} alt="Logo" />
                  <span className="font-[Montserrat,_sans-serif] text-[20px] text-[#ff700e]">
                    Ariz Supermart
                  </span>
                </Link>
              </div>
            </div>
            <div className="md-lg:w-full w-9/12">
              <div className="flex justify-between md-lg:justify-center items-center flex-wrap pl-8">
                <ul className="flex justify-center items-center gap-3 text-sm font-bold uppercase md-lg:hidden">
                  <li
                    className={`p-2 block ${
                      pathname === "/" ? "text-secondary" : "text-slate-600"
                    }`}
                  >
                    <Link
                      to="/"
                      className={`p-2 block ${
                        pathname === "/" ? "text-secondary" : "text-slate-600"
                      }`}
                    >
                      Home
                    </Link>
                  </li>
                  <li
                    className={`p-2 block ${
                      pathname === "/" ? "text-secondary" : "text-slate-600"
                    }`}
                  >
                    <Link
                      to="/shops"
                      className={`p-2 block ${
                        pathname === "/shops"
                          ? "text-secondary"
                          : "text-slate-600"
                      }`}
                    >
                      Shop
                    </Link>
                  </li>
                  <li
                    className={`p-2 block ${
                      pathname === "/" ? "text-secondary" : "text-slate-600"
                    }`}
                  >
                    <Link
                      to="/about"
                      className={`p-2 block ${
                        pathname === "/about"
                          ? "text-secondary"
                          : "text-slate-600"
                      }`}
                    >
                      About
                    </Link>
                  </li>
                  <li>
                    <div className=" md-lg:w-full">
                      <div className="flex border-2 rounded-[10px] h-[50px] items-center relative gap-5">
                        <div className="relative  after:absolute after:h-[25px] after:w-[1px] after:bg-[#afafaf] after:-right-[15px] md:hidden">
                          <select
                            onChange={(e) => setCategory(e.target.value)}
                            className=" text-slate-600 font-semibold bg-transparent px-2 h-full outline-0 border-none"
                            name=""
                            id=""
                          >
                            <option value="">Select category</option>
                            {categorys.map((c, i) => (
                              <option key={i} value={c.name}>
                                {c.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <input
                          className="w-full relative drop-shadow-lg bg-transparent font-normal text-slate-500 outline-0 px-3 h-full"
                          onChange={(e) => setSearchValue(e.target.value)}
                          type="text"
                          name=""
                          id=""
                          placeholder="what do you need"
                        />
                        <button
                          onClick={search}
                          className="bg-[#0d3858] rounded-[10px] right-0 absolute px-3 h-9 mr-1 font-semibold uppercase text-white"
                        >
                          <ImSearch />
                        </button>
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="flex md-lg:hidden justify-center items-center gap-4">
                  <div className="flex justify-center  gap-4">
                    <button
                      onClick={() =>
                        navigate(userInfo ? "/dashboard/my-wishlist" : "/login")
                      }
                      className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
                    >
                      <span className="text-xl text-[#212730] ">
                        <TiHeartFullOutline />
                      </span>
                      {wishlist_count !== 0 && (
                        <div className="w-[20px] h-[20px] absolute bg-secondary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                          {wishlist_count}
                        </div>
                      )}
                    </button>
                    <button
                      onClick={redirect_card_page}
                      className="relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]"
                    >
                      <span className="text-xl text-[#212730]">
                        <MdShoppingCart />
                      </span>
                      {card_product_count !== 0 && (
                        <div className="w-[20px] h-[20px] absolute bg-secondary rounded-full text-white flex justify-center items-center -top-[3px] -right-[5px]">
                          {card_product_count}
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='hidden md-lg:block'>
                <div className='w-[85%] mx-auto my-0'>
                    <div className='flex border rounded-[10px] drop-shadow-lg h-[50px] items-center relative gap-5'>

                        <input className='w-full relative  bg-transparent text-slate-500 outline-0 px-3 h-full' onChange={(e) => setSearchValue(e.target.value)} type="text" name="" id="" placeholder='what do you need' />
                        <button onClick={search} className='bg-secondary rounded-[10px] right-0 absolute px-4 h-full font-semibold uppercase text-white'><ImSearch /></button>
                    </div>
                </div>
            </div> */}
    </div>
  );
};

export default Headers;
